import React from 'react';
import ReactDOM from 'react-dom';
import './resources/css/index.css';
import App from './components/App';
import './language/language'
import 'bootstrap/dist/css/bootstrap.css';


ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
